<div [formGroup]="parentForm">
    <label>{{name}}</label>
    <label class="switch" (change)="onChange()" formGroupName="body">
        <input type="checkbox" formControlName="{{formControlInputName}}">
        <span class="slider round"></span>
    </label>
    <label>{{state == false ? 'Off' : 'On'}}</label>
</div>